/** @format */

import React from 'react'
import Waterfall from '../waterfall';
import './index.less'

export default (props) => {
  const { data } = props
  return (
    <div className={`boardContainer`}>
      <div className='boardHeader row'>
        <div className='infoItem row'>
          <div className='label'>套图ID：</div>
          <div className='value'>{data?.id}</div>
        </div>
        <div className='infoItem row'>
          <div className='label'>状态：</div>
          <div className='value'>{data?.status}</div>
        </div>
        <div className='infoItem row'>
          <div className='label'>入库：</div>
          <div className='value'>{data?.createTime}</div>
        </div>
      </div>
      <Waterfall />
    </div>
  )
}
